import { Box, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

export function formatSummaryToJSX(summary) {
  const lines = summary.split('\n');
  const elements = [];
  let listItems = [];

  const flushList = () => {
  if (listItems.length) {
    elements.push(
      <List dense sx={{ pl: 2, mb: 0 }}>
        {listItems.map((item, idx) => (
          <ListItem
            key={idx}
            alignItems="flex-start"
            disableGutters
            sx={{ pb: 0.5 }}
          >
            <ListItemText
              primary={
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: parseInlineMarkdown(item) }}
                />
              }
            />
          </ListItem>
        ))}
      </List>
    );
    listItems = [];
  }
};


  const parseInlineMarkdown = (text) => {
    const badge = (label, colorLight, colorDark) => {
      return `
        <span class="badge-${label.toLowerCase()}" style="
          display:inline-block;
          padding:2px 6px;
          border-radius:4px;
          font-size:12px;
          margin-right:6px;
          color:#fff;
        ">${label}</span>`;
    };

    text = text.replace(/\*\*Critical.*?\*\*/gi, badge('Critical', '#f44336', '#ef5350'));
    text = text.replace(/\*\*Warning.*?\*\*/gi, badge('Warning', '#ffa726', '#ffb74d'));
    text = text.replace(/\*\*Info.*?\*\*/gi, badge('Info', '#29b6f6', '#4fc3f7'));

    // Code inline
    text = text.replace(
      /`(.+?)`/g,
      `<code class="code-inline" style="
        padding:2px 4px;
        border-radius:3px;
        font-family:monospace;
      ">$1</code>`
    );

    // Bold
    text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

    return text;
  };

  lines.forEach((line, index) => {
    if (/^## /.test(line)) {
      flushList();
      elements.push(
        <Typography key={`h2-${index}`} variant="h6" gutterBottom sx={{ mt: 2 }}>
          {line.replace(/^## /, '')}
        </Typography>
      );
    } else if (/^\* /.test(line) || /^\s*[-•] /.test(line)) {
      listItems.push(line.replace(/^\* |^\s*[-•] /, ''));
    } else if (line.trim() === '') {
      flushList();
    } else {
      flushList();
      elements.push(
        <Typography
          key={`p-${index}`}
          variant="body2"
          paragraph
          dangerouslySetInnerHTML={{ __html: parseInlineMarkdown(line) }}
          sx={(theme) => ({
            color: theme.palette.mode === 'dark' ? '#ccc' : '#444',
          })}
        />
      );
    }
  });

  flushList();

  return (
    <Box
      sx={{
        lineHeight: 1.8,
        fontSize: '0.95rem',
        '& .badge-critical': {
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#ef5350' : '#f44336',
        },
        '& .badge-warning': {
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#ffb74d' : '#ffa726',
        },
        '& .badge-info': {
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#4fc3f7' : '#29b6f6',
        },
        '& .code-inline': {
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#2e2e2e' : '#f5f5f5',
          color: (theme) => theme.palette.mode === 'dark' ? '#e0e0e0' : '#212121',
        }
      }}
    >
      {elements}
    </Box>
  );
}
